<div class="my-list-wrapper">
  <app-search-bar
    [placeholder]="searchPlaceholder"
    [tooltip]="searchTooltip"
    (searchChanged)="filterAssistants($event)"
  ></app-search-bar>

  <app-data-table
    *ngIf="assistants && assistants.length > 0; else noConversations"
    [data]="filteredAssistants"
    [columns]="columns"
    [presentationMode]="'cards'"
    (rowClicked)="onRowClick($event)"
    (actionClicked)="onActionClick($event)"
  ></app-data-table>

  <app-loading-spinner *ngIf="loading"></app-loading-spinner>

  <ng-template #noConversations>
    <app-chat-card
      class="no-conversations-card"
      *ngIf="!loading"
      [header]="''"
      [description]="'There are no assistants in this workspace.'"
      [button_label]="'Select Workspace'"
      [route]="'/workspaces'"
      [showActions]="true"
    >
    </app-chat-card>
  </ng-template>
</div>
